import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static targets = ["item"]
  static values = { url: String }

  connect() {
    this._dragged = null
    this._placeholder = this._makePlaceholder()
  }

  disconnect() {
    this._placeholder.remove()
  }

  dragstart(event) {
    const item = event.currentTarget
    if (!this._isMoveable(item)) {
      event.preventDefault()
      return
    }
    this._dragged = item
    requestAnimationFrame(() => item.classList.add("opacity-25"))
  }

  dragend(event) {
    event.currentTarget.classList.remove("opacity-25")
    if (this._dragged && this._placeholder.parentNode) {
      this._placeholder.parentNode.insertBefore(this._dragged, this._placeholder)
    }
    this._placeholder.remove()
    if (this._dragged) {
      this._submitOrder()
      this._dragged = null
    }
  }

  dragover(event) {
    if (!this._dragged) return
    const target = event.currentTarget
    if (target === this._dragged || !this._isMoveable(target)) return

    event.preventDefault()

    const rect = target.getBoundingClientRect()
    if (event.clientY < rect.top + rect.height / 2) {
      target.parentNode.insertBefore(this._placeholder, target)
    } else {
      target.parentNode.insertBefore(this._placeholder, target.nextSibling)
    }
  }

  drop(event) {
    event.preventDefault()
  }

  _isMoveable(item) {
    return item.dataset.moveable === "true"
  }

  _makePlaceholder() {
    const el = document.createElement("div")
    el.className = "panel mb-2"
    el.style.cssText = "border: 2px dashed var(--bs-primary) !important; min-height: 2.5rem; opacity: 0.4;"
    return el
  }

  async _submitOrder() {
    const ids = this.itemTargets
      .filter(el => this._isMoveable(el))
      .map(el => el.dataset.id)

    await patch(this.urlValue, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
      body: JSON.stringify({ ids }),
      contentType: "application/json"
    })
  }
}
